// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d10131b3","239":"f339f04d","667":"331cb12a"}[chunkId] + ".chunk.js";
};